// templates
export const SPEC = 'spec';
export const PROPS = 'props';
export const STATE = 'state';
export const VIEW = 'view';
export const EVENTS = 'events';
export const CHILDREN = 'children';
export const DATASOURCES = 'datasources';
export const VERSION = 'version';
export const UQL_PAGINATED = 'uqlPaginated';

// globals
export const DEFAULT_TIME_RANGE_SINCE = '-PT6H';
export const DEFAULT_TIME_RANGE_UNTIL = 'now';

export const DEFAULT_BASE_URL = 'alameda-c0-test-02.saas.appd-test.com/ui';

export const CONTAINER_TEMPLATES_WITH_DEFAULT_BG_COLOR = [
  'dashify:Card',
  'dashify:CardWithTitle',
  'dashify:CardWithEditProps',
];

export const BG_COLOR_REGEX_PATTERN = /\b(bg-\S+)\b/g;

export const FEATURE_FLAGS_STORE_KEY = 'dashify-feature-flags-store';

export const GLOBALS_VARIABLES = '/globals/variables';
export const GLOBALS_VARIABLES_SINCE = '/globals/variables/since';
export const GLOBALS_VARIABLES_UNTIL = '/globals/variables/until';
export const GLOBALS_THEME = '/globals/currentTheme';
export const GLOBALS_USERINFO = '/globals/userInfo';
